const TIER_RANK = {
    top: 1,
    basic: 2,
    dangerous: 3,
};

const PRIORITY_RANK = {
    high: 1,
    medium: 2,
    low: 3,
};

function tierRank(ticket) {
    const tier = String(ticket?.customer_rating_tier || '').toLowerCase();

    return TIER_RANK[tier] ?? 4;
}

function priorityRank(ticket) {
    const priority = String(ticket?.priority || '').toLowerCase();

    return PRIORITY_RANK[priority] ?? 3;
}

function createdAtMs(ticket) {
    const parsed = Date.parse(ticket?.created_at || '');

    return Number.isNaN(parsed) ? 0 : parsed;
}

/**
 * Open Kanban columns: Fascia (Top → Basic → Dangerous → unknown), then priority, then FIFO created_at.
 *
 * @param {Array<Record<string, unknown>>} tickets
 * @returns {Array<Record<string, unknown>>}
 */
export function queueSortTickets(tickets) {
    return [...(tickets || [])].sort((left, right) => {
        const byTier = tierRank(left) - tierRank(right);
        if (byTier !== 0) {
            return byTier;
        }

        const byPriority = priorityRank(left) - priorityRank(right);
        if (byPriority !== 0) {
            return byPriority;
        }

        const byCreated = createdAtMs(left) - createdAtMs(right);
        if (byCreated !== 0) {
            return byCreated;
        }

        return Number(left?.id || 0) - Number(right?.id || 0);
    });
}
